import React from 'react';

import { OilSettings } from 'screens/shared';

const DieselTransOil = (props) => {
  const engineValues = {
    normal: '400.0',
    reset: '800.0'
  };

  return <OilSettings engineValues={engineValues} {...props} />;
};

export default DieselTransOil;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselSettings/DieselTransOil/DieselTransOil.js